import styled, { css } from 'styled-components';

import { GenericSpan, LeftSection, FlexDiv } from 'commonStyles';

export const NavWrapper = styled(LeftSection)`
	border-right: 1px solid #D6D6D8;

`;

export const SideBarNav = styled.ul`
	width: 210px;
	position: fixed;
	top: 135px;
`;

export const SideBarNavItem = styled(FlexDiv)`
	padding: 12px 8px;
`;

export const NavText = styled(GenericSpan)`
	line-height: 20px;
	width: 100%;
	${(props) => props.active && css`
	background: #FFF1F1;
	border-radius: 4px;
	color: #000000;
	font-weight: 700;
	position: relative;
	padding: 12px 8px;
	cursor: pointer;
	font-size: 14px;
	line-height: 20px;
	&:before {
		content: '';
		top: 0;
		width: 3px;
		height: 100%;
		margin-right: 8px;
		position: absolute;
		left: 0px;
		display: flex;
		flex-shrink: 0;
		background-color: #FF664B;
	}`
}
`;
